import { observer } from "mobx-react";
import ComparisionCard from "../components/ComparisionCard";
import ProductModel from "../stores/ProductModel";
import { store } from "../stores/Store";
import Collapse from "../components/Collapse";
import { useState, useRef, useCallback } from "react";
import { Modal } from "../components/Modal";
import { Gtm } from "../utils/Gtm";
import { Clarity } from "../utils/Clarity";
import { _t } from '../utils/Lang';


const MattressComparisionModal = observer(() => {

    const [opened, setOpened] = useState([
        'section1',
    ]);

    const isOpened = (section) => opened.includes(section);
    const toggleSection = (section) => {
        if (isOpened(section)) {
            setOpened(opened.filter(item => item !== section));
        } else {
            // setOpened([...opened, section]);
            setOpened([section]);
        }
    }

    const scrollRef = useRef(null);

    const scroll = useCallback((direction) => {
        if (scrollRef.current) {
            const by = scrollRef.current.offsetWidth / 3;
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -by : by,
                behavior: 'smooth'
            });
        }
    }, []);

    return <Modal
        className="modal-lg"
        onClose={e => {
            store.closeComparision();
        }}
        isOpen={store.isOpenComparision}

    >
        <button className="ModalComparision__arrow ModalComparision__arrow--left" onClick={() => scroll('left')} aria-label="Scroll left">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </button>

        <button className="ModalComparision__arrow ModalComparision__arrow--right" onClick={() => scroll('right')} aria-label="Scroll right">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </button>
        <div className="ModalComparision">
            <div className='c-h1'>{_t('compare_available')}</div>
            {/* <div className="c-p fw-bold">Sprawdź jak wygląda wybrana wysokość wezgłowia</div> */}
            <div className="w-100" ref={scrollRef} style={{ overflowX: 'auto', scrollSnapType: 'x mandatory' }}>
                <div className="ModalComparision__scroll-x d-flex g-1 g-md-2 pb-4">
                    {
                        store.mattressComparision.map((item: ProductModel, index) => {
                            return <ComparisionCard
                                key={index}
                                item={item}

                                onMoreClick={() => {

                                    if (item.url) {
                                        window.open(item.url, '_blank');

                                        Gtm.push({
                                            event: "konfigurator_click",
                                            ecommerce: {
                                                button_name: `dowiedz się wiecej - ${item.name}`,
                                                value: Gtm.getPrice(),
                                                items: [
                                                    {
                                                        item_name: Gtm.getProductName(),
                                                        item_id: Gtm.getProductId(),
                                                        item_brand: "MyBed",
                                                        item_category: "Łóżka",
                                                        item_variant: Gtm.getVariantStr(),
                                                    }
                                                ]
                                            }
                                        });
                                        Clarity.push(`konfigurator_click - dowiedz się wiecej - ${item.name}`);
                                        return;
                                    }

                                }}

                            >


                                <Collapse
                                    title={() => {
                                        return <div className="ComparisionCard__header d-flex w-100 a-center">

                                            {_t('who_for')} <svg className="Collapse__arrow ms-auto" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.00056 6.99988L0.282227 1.28154L1.04473 0.519043L6.00056 5.47488L10.9564 0.519043L11.7189 1.28154L6.00056 6.99988Z" fill="#1F1F1F" />
                                            </svg>
                                        </div>

                                    }}
                                    onClick={() => {
                                        toggleSection('section1')
                                    }}

                                    isOpen={isOpened('section1')}
                                    className="">

                                    {/* <div className="ComparisionCard__header">Dla kogo materac?</div> */}
                                    {
                                        <ul>
                                            {
                                                item.mattress_for_whom.map((item, index) => {
                                                    return <li key={index}>
                                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5.041 8.66709L9.30517 4.40292L8.83333 3.93109L5.041 7.72342L3.141 5.82342L2.66917 6.29525L5.041 8.66709ZM6.00217 12.0619C5.1725 12.0619 4.39244 11.9045 3.662 11.5896C2.93167 11.2747 2.29633 10.8474 1.756 10.3076C1.21567 9.76781 0.787944 9.13303 0.472833 8.40325C0.157611 7.67359 0 6.89387 0 6.06409C0 5.23442 0.157444 4.45436 0.472333 3.72392C0.787222 2.99359 1.21456 2.35825 1.75433 1.81792C2.29411 1.27759 2.92889 0.849865 3.65867 0.534753C4.38833 0.219531 5.16806 0.0619202 5.99783 0.0619202C6.8275 0.0619202 7.60756 0.219365 8.338 0.534254C9.06833 0.849143 9.70367 1.27648 10.244 1.81625C10.7843 2.35603 11.2121 2.99081 11.5272 3.72059C11.8424 4.45025 12 5.22998 12 6.05975C12 6.88942 11.8426 7.66948 11.5277 8.39992C11.2128 9.13025 10.7854 9.76559 10.2457 10.3059C9.70589 10.8463 9.07111 11.274 8.34133 11.5891C7.61167 11.9043 6.83194 12.0619 6.00217 12.0619ZM6 11.3953C7.48889 11.3953 8.75 10.8786 9.78333 9.84525C10.8167 8.81192 11.3333 7.55081 11.3333 6.06192C11.3333 4.57303 10.8167 3.31192 9.78333 2.27859C8.75 1.24525 7.48889 0.728587 6 0.728587C4.51111 0.728587 3.25 1.24525 2.21667 2.27859C1.18333 3.31192 0.666667 4.57303 0.666667 6.06192C0.666667 7.55081 1.18333 8.81192 2.21667 9.84525C3.25 10.8786 4.51111 11.3953 6 11.3953Z" fill="#AD864D" />
                                                        </svg>

                                                        {item}
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    }
                                    <hr />
                                </Collapse>


                                <Collapse
                                    title={() => {
                                        return <div className="ComparisionCard__header d-flex w-100 a-center">

                                            {_t('mattress_features')} <svg className="Collapse__arrow ms-auto" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.00056 6.99988L0.282227 1.28154L1.04473 0.519043L6.00056 5.47488L10.9564 0.519043L11.7189 1.28154L6.00056 6.99988Z" fill="#1F1F1F" />
                                            </svg>
                                        </div>

                                    }}
                                    onClick={() => {
                                        toggleSection('section2')
                                    }}

                                    isOpen={isOpened('section2')}
                                    className="">


                                    {/* <div className="ComparisionCard__header">Cechy materaca</div> */}
                                    {
                                        <ul>
                                            {
                                                item.mattress_features.map((item, index) => {
                                                    return <li key={index}>
                                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5.041 8.66709L9.30517 4.40292L8.83333 3.93109L5.041 7.72342L3.141 5.82342L2.66917 6.29525L5.041 8.66709ZM6.00217 12.0619C5.1725 12.0619 4.39244 11.9045 3.662 11.5896C2.93167 11.2747 2.29633 10.8474 1.756 10.3076C1.21567 9.76781 0.787944 9.13303 0.472833 8.40325C0.157611 7.67359 0 6.89387 0 6.06409C0 5.23442 0.157444 4.45436 0.472333 3.72392C0.787222 2.99359 1.21456 2.35825 1.75433 1.81792C2.29411 1.27759 2.92889 0.849865 3.65867 0.534753C4.38833 0.219531 5.16806 0.0619202 5.99783 0.0619202C6.8275 0.0619202 7.60756 0.219365 8.338 0.534254C9.06833 0.849143 9.70367 1.27648 10.244 1.81625C10.7843 2.35603 11.2121 2.99081 11.5272 3.72059C11.8424 4.45025 12 5.22998 12 6.05975C12 6.88942 11.8426 7.66948 11.5277 8.39992C11.2128 9.13025 10.7854 9.76559 10.2457 10.3059C9.70589 10.8463 9.07111 11.274 8.34133 11.5891C7.61167 11.9043 6.83194 12.0619 6.00217 12.0619ZM6 11.3953C7.48889 11.3953 8.75 10.8786 9.78333 9.84525C10.8167 8.81192 11.3333 7.55081 11.3333 6.06192C11.3333 4.57303 10.8167 3.31192 9.78333 2.27859C8.75 1.24525 7.48889 0.728587 6 0.728587C4.51111 0.728587 3.25 1.24525 2.21667 2.27859C1.18333 3.31192 0.666667 4.57303 0.666667 6.06192C0.666667 7.55081 1.18333 8.81192 2.21667 9.84525C3.25 10.8786 4.51111 11.3953 6 11.3953Z" fill="#AD864D" />
                                                        </svg>

                                                        {item}
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    }
                                    <hr />


                                </Collapse>
                                <Collapse
                                    title={({ open }) => {
                                        return <div className="ComparisionCard__header d-flex w-100 a-center">

                                            {_t('comfort_zones')} <svg className="Collapse__arrow ms-auto" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.00056 6.99988L0.282227 1.28154L1.04473 0.519043L6.00056 5.47488L10.9564 0.519043L11.7189 1.28154L6.00056 6.99988Z" fill="#1F1F1F" />
                                            </svg>
                                        </div>
                                    }}
                                    onClick={() => {
                                        toggleSection('section3')
                                    }}
                                    isOpen={isOpened('section3')}
                                    className=""

                                >
                                    {/* <div className="ComparisionCard__header">Strefy komfortu</div> */}
                                    <div className="ComparisionCard__description mt-0 mb-3">{item.comfort_zones_text}</div>
                                    {
                                        <ul>
                                            {
                                                item.comfort_zones_bullets.map((item, index) => {
                                                    return <li key={index}>
                                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M5.041 8.66709L9.30517 4.40292L8.83333 3.93109L5.041 7.72342L3.141 5.82342L2.66917 6.29525L5.041 8.66709ZM6.00217 12.0619C5.1725 12.0619 4.39244 11.9045 3.662 11.5896C2.93167 11.2747 2.29633 10.8474 1.756 10.3076C1.21567 9.76781 0.787944 9.13303 0.472833 8.40325C0.157611 7.67359 0 6.89387 0 6.06409C0 5.23442 0.157444 4.45436 0.472333 3.72392C0.787222 2.99359 1.21456 2.35825 1.75433 1.81792C2.29411 1.27759 2.92889 0.849865 3.65867 0.534753C4.38833 0.219531 5.16806 0.0619202 5.99783 0.0619202C6.8275 0.0619202 7.60756 0.219365 8.338 0.534254C9.06833 0.849143 9.70367 1.27648 10.244 1.81625C10.7843 2.35603 11.2121 2.99081 11.5272 3.72059C11.8424 4.45025 12 5.22998 12 6.05975C12 6.88942 11.8426 7.66948 11.5277 8.39992C11.2128 9.13025 10.7854 9.76559 10.2457 10.3059C9.70589 10.8463 9.07111 11.274 8.34133 11.5891C7.61167 11.9043 6.83194 12.0619 6.00217 12.0619ZM6 11.3953C7.48889 11.3953 8.75 10.8786 9.78333 9.84525C10.8167 8.81192 11.3333 7.55081 11.3333 6.06192C11.3333 4.57303 10.8167 3.31192 9.78333 2.27859C8.75 1.24525 7.48889 0.728587 6 0.728587C4.51111 0.728587 3.25 1.24525 2.21667 2.27859C1.18333 3.31192 0.666667 4.57303 0.666667 6.06192C0.666667 7.55081 1.18333 8.81192 2.21667 9.84525C3.25 10.8786 4.51111 11.3953 6 11.3953Z" fill="#AD864D" />
                                                        </svg>
                                                        <span dangerouslySetInnerHTML={{ __html: item }}>

                                                        </span>

                                                    </li>
                                                })
                                            }
                                        </ul>
                                    }
                                </Collapse>

                            </ComparisionCard>
                        })
                    }

                </div>

            </div>

        </div>
        {/* <InfoBar>
                <div className="row a-center">
                    <div className="col-12 col-md-9 mb-2 mb-md-0">
                        Nadal nie wiesz jaki <i>materac wybrać</i>?
                    </div>
                    <div className="col-12 col-md-3">
                        <Button onClick={() => {
                            store.quiz.open();
                        }} className="btn-sm w-100 primary">Rozwiąż quiz</Button>
                    </div>
                </div>

            </InfoBar> */}


    </Modal>
})

MattressComparisionModal.displayName = "MattressComparisionModal"

export default MattressComparisionModal